import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

const SubscriptionPrompt = ({
  open,
  onClose,
  title = 'Subscription required',
  message = 'Please purchase a subscription to access this feature.',
  primaryAction = { label: 'OK', onClick: onClose, color: '#3BB3AE' },
  secondaryAction = null,
  PaperProps = {},
  children,
  keepMounted = false,
  icon = null, // React node for an illustration/icon
}) => {
  const defaultPaper = {
    style: {
      backgroundColor: '#0e1b1b',
      color: 'white',
      borderRadius: 12,
      minWidth: 300,
      padding: 0,
    },
  };

  const mergedPaper = { ...defaultPaper, ...PaperProps };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={mergedPaper} keepMounted={keepMounted}>
      <DialogTitle sx={{ borderBottom: '1px solid #484848', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {icon ? (
            <Box sx={{ mr: 1 }}>{icon}</Box>
          ) : (
            <Box sx={{ width: 44, height: 44, borderRadius: '50%', background: 'linear-gradient(90deg,#053838,#0b6b68)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 22, mr: 1 }}>📲</Box>
          )}
          <Typography variant="h6" sx={{ color: 'white' }}>{title}</Typography>
        </Box>
        <IconButton onClick={onClose} aria-label="close" size="small" sx={{ color: 'rgba(255,255,255,0.7)' }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 3, pb: 2 }}>
        {children ? (
          children
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1" sx={{ color: 'white' }}>{message}</Typography>
            <Typography variant="body2" sx={{ color: 'var(--muted)', mt: 1 }}>{/* subtle helper text if needed */}</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ padding: '16px', gap: 1, flexWrap: 'wrap' }}>
        {secondaryAction ? (
          <Button
            onClick={secondaryAction.onClick}
            variant="outlined"
            sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.12)', minWidth: 100 }}
          >
            {secondaryAction.label}
          </Button>
        ) : null}

        {primaryAction ? (
          <Button
            onClick={primaryAction.onClick}
            variant="contained"
            sx={{
              background: primaryAction.color ? primaryAction.color : 'linear-gradient(90deg,#3BB3AE,#00ffc8)',
              '&:hover': { background: primaryAction.hover || '#48D1CC' },
              minWidth: 120,
            }}
          >
            {primaryAction.label}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default SubscriptionPrompt;
